import { memo } from "react";
import type { LoaderCommonProps } from "../types";
import { tokens } from "../styles/tokens";
import { Skeleton } from "./Skeleton";

export const CardLoader = memo(function CardLoader({
  animated = true,
  width,
  height,
  className,
}: LoaderCommonProps) {
  return (
    <div
      className={className}
      style={{
        width,
        height,
        background: "#fff",
        borderRadius: tokens.radius,
        boxShadow: tokens.shadowMd,
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div style={{ position: "relative", width: "100%", paddingBottom: "56.25%" }}>
        <Skeleton
          width="100%"
          height="100%"
          animated={animated}
          borderRadius={0}
          style={{ position: "absolute", inset: 0 }}
        />
      </div>
      <div style={{ padding: tokens.spacing.md, display: "flex", flexDirection: "column", gap: tokens.spacing.sm }}>
        <Skeleton width="70%" height={20} animated={animated} />
        <Skeleton width="100%" height={14} animated={animated} />
        <Skeleton width="85%" height={14} animated={animated} />
        <Skeleton width={100} height={32} borderRadius={tokens.radius} animated={animated} style={{ marginTop: 4 }} />
      </div>
    </div>
  );
});
